import React from 'react';
import { Button, Badge } from 'react-bootstrap';
import { FaArrowLeft, FaHistory } from 'react-icons/fa';

const AgentHeader = ({ 
  agent, 
  targetId, 
  agentTypeLabel, 
  environment,
  restoredFromLogs,
  onGoBackToAgent, 
  onGoBackToParentAgent,
  onViewLogs 
}) => {
  return (
    <div className="agent-header">
      <div className="agent-title-container">
        <h1 className="agent-title">Test {agentTypeLabel}</h1>
        <div className="agent-subtitle-wrapper">
          <p className="agent-subtitle">
            Agent ID: {agent?.id || targetId}
            {agent?.agentNumber && <span> | Number: {agent.agentNumber}</span>}
            {environment && <span> | Environment: {environment}</span>}
          </p>
          {restoredFromLogs && (
            <div className="mt-3">
              <Badge bg="info" className="px-3 py-2">
                DATA RESTORED FROM EXECUTION LOGS
              </Badge>
            </div>
          )}
        </div>
      </div>
      
      <div className="agent-actions">
        <Button 
          variant="outline-primary" 
          onClick={onGoBackToAgent}
          className="action-button"
          style={{
            minWidth: '160px',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '8px',
            paddingBottom: '8px',
            whiteSpace: 'nowrap',
            fontSize: '0.875rem'
          }}
        >
          <FaArrowLeft className="me-2" />
          Develop Agent
        </Button>

        <Button 
          variant="outline-primary" 
          onClick={onGoBackToParentAgent}
          className="action-button"
          style={{
            minWidth: '160px',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '8px',
            paddingBottom: '8px',
            whiteSpace: 'nowrap',
            fontSize: '0.875rem'
          }}
        >
          <FaArrowLeft className="me-2" />
          Back to parent agent
        </Button>
        
        <Button 
          variant="outline-primary" 
          onClick={onViewLogs}
          className="action-button"
          style={{
            minWidth: '160px',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '8px',
            paddingBottom: '8px',
            whiteSpace: 'nowrap',
            fontSize: '0.875rem'
          }}
        >
          <FaHistory className="me-2" />
          View logs
        </Button>
      </div>
    </div>
  );
};

export default AgentHeader;